import * as Yup from 'yup'
import { FormRegex } from '../../models/Common'
import {
  FeedbackReferenceTypes,
  FeedbackTypes,
  IFeedbackValidator,
} from '../../models/Feedback'

export class FeedbackValidator {
  private provideFeedBackId: string
  private complaintId: string
  private decisionReviewId: string
  private serviceAreaIdAi: string

  constructor(validator: IFeedbackValidator) {
    this.provideFeedBackId = validator.feedbackTypes?.find(
      (p) => p.name === String(FeedbackTypes.ProvideFeedback)
    )?.id
    this.complaintId = validator.feedbackTypes?.find(
      (p) => p.name === String(FeedbackTypes.MakeComplaint)
    )?.id
    this.decisionReviewId = validator.feedbackTypes?.find(
      (p) => p.name === String(FeedbackTypes.RequestReviewDecision)
    )?.id
    this.serviceAreaIdAi = validator.serviceAreaAi?.id
  }

  getRule() {
    return Yup.object({
      feedbackTypeId: Yup.string().required(
        'This field cannot be empty, it is required.'
      ),
      customerReferenceTypeId: Yup.string().required(
        'This field cannot be empty, it is required.'
      ),
      responseRequired: Yup.string().required(
        'This field cannot be empty, it is required.'
      ),
      serviceAreaId: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return (
              this.provideFeedBackId === feedbackTypeId ||
              this.complaintId === feedbackTypeId
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      servicePointId: Yup.string()
        .when(['feedbackTypeId', 'serviceAreaId'], {
          is: (feedbackTypeId, serviceAreaId) => {
            return (
              (this.provideFeedBackId === feedbackTypeId &&
                this.serviceAreaIdAi !== serviceAreaId) ||
              this.complaintId === feedbackTypeId
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      serviceIssueId: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return (
              this.provideFeedBackId === feedbackTypeId ||
              this.complaintId === feedbackTypeId
            )
          },
          then: Yup.string()
            .optional()
            //.required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      issue: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return (
              this.provideFeedBackId === feedbackTypeId ||
              this.complaintId === feedbackTypeId
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(1000, 'Must be exactly 1000 or less characters'),
        })
        .nullable(true),
      crn: Yup.string()
        .when('customerReferenceTypeId', {
          is: (customerReferenceTypeId) => {
            return (
              customerReferenceTypeId !== null &&
              customerReferenceTypeId !== undefined &&
              customerReferenceTypeId === String(FeedbackReferenceTypes.CRN)
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      matterNumber: Yup.string()
        .when('customerReferenceTypeId', {
          is: (customerReferenceTypeId) => {
            return (
              customerReferenceTypeId !== null &&
              customerReferenceTypeId !== undefined &&
              customerReferenceTypeId ===
                String(FeedbackReferenceTypes.MatterNumber)
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      enquiryNumber: Yup.string()
        .when('customerReferenceTypeId', {
          is: (customerReferenceTypeId) => {
            return (
              customerReferenceTypeId !== null &&
              customerReferenceTypeId !== undefined &&
              customerReferenceTypeId ===
                String(FeedbackReferenceTypes.EnquiryNumber)
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(50, 'Must be exactly 50 or less characters'),
        })
        .nullable(true),
      accountEmail: Yup.string()
        .when('customerReferenceTypeId', {
          is: (customerReferenceTypeId) => {
            return (
              customerReferenceTypeId !== null &&
              customerReferenceTypeId !== undefined &&
              customerReferenceTypeId ===
                String(FeedbackReferenceTypes.MyAccount)
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .matches(FormRegex.Email, 'Please enter a valid email address')
            .max(100, 'Must be exactly 100 or less characters'),
        })
        .nullable(true),
      firstName: Yup.string()
        .when('responseRequired', {
          is: (responseRequired) => {
            return (
              responseRequired !== null &&
              responseRequired !== undefined &&
              responseRequired === 'Yes'
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(100, 'Must be exactly 100 or less characters'),
        })
        .nullable(true),
      lastName: Yup.string()
        .when('responseRequired', {
          is: (responseRequired) => {
            return (
              responseRequired !== null &&
              responseRequired !== undefined &&
              responseRequired === 'Yes'
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(100, 'Must be exactly 100 or less characters'),
        })
        .nullable(true),
      emailAddress: Yup.string()
        .when('responseRequired', {
          is: (responseRequired) => {
            return (
              responseRequired !== null &&
              responseRequired !== undefined &&
              responseRequired === 'Yes'
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .matches(FormRegex.Email, 'Please enter a valid email address')
            .max(100, 'Must be exactly 100 or less characters')
            .nullable(true),
        })
        .when('responseRequired', {
          is: (responseRequired) => {
            return (
              responseRequired !== null &&
              responseRequired !== undefined &&
              responseRequired === 'No'
            )
          },
          then: Yup.string()
            .optional()
            .matches(FormRegex.Email, 'Please enter a valid email address')
            .max(100, 'Must be exactly 100 or less characters')
            .nullable(true),
        })
        .nullable(true),
      phoneNumber: Yup.string()
        .when('responseRequired', {
          is: (responseRequired) => {
            return (
              responseRequired !== null &&
              responseRequired !== undefined &&
              responseRequired === 'Yes'
            )
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .matches(FormRegex.Phone, 'Please enter a valid phone number')
            .max(20, 'Must be exactly 20 or less characters')
            .nullable(true),
        })
        .nullable(true),
      decision: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return this.decisionReviewId === feedbackTypeId
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(150, 'Must be exactly 150 or less characters'),
        })
        .nullable(true),
      reasonBehindWrongDecision: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return this.decisionReviewId === feedbackTypeId
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(350, 'Must be exactly 350 or less characters'),
        })
        .nullable(true),
      evidenceForWrongDecision: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return this.decisionReviewId === feedbackTypeId
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(350, 'Must be exactly 350 or less characters'),
        })
        .nullable(true),
      expectedOutcome: Yup.string()
        .when('feedbackTypeId', {
          is: (feedbackTypeId) => {
            return this.decisionReviewId === feedbackTypeId
          },
          then: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .max(350, 'Must be exactly 350 or less characters'),
        })
        .nullable(true),
    })
  }
}
